const config = {
    env: 'local',
    // apiUrl: "http://15.206.68.199:8527/admin/v1",
    apiUrl: "https://api.amouraa.app/admin/v1",
    // apiUrl: "http://localhost:4000/admin/v1",
    // apiUrl: "https://p9rf4sf9-5555.inc1.devtunnels.ms/admin/v1",
}

export default config;